import { useViewEvent } from 'features/events/context/ViewEvent';
import i18n from 'i18n';

const EventInfo = () => {
  const { event } = useViewEvent();

  return (
    <div className="flex flex-1 gap-4 items-center md:w-2/3 px-4">
      <img
        src={event?.photo.url}
        alt={event?.title}
        className="w-[56px] h-[70px] md:w-[80px] md:h-[100px] object-cover rounded-lg"
      />
      <div className="flex flex-col gap-[2px] md:gap-1">
        <h2 className="text-xl font-black md:text-[24px] md:mb-2">
          {event?.title}
        </h2>
        <p className="text-sm text-neutral-600 font-semibold md:text-lg">
          {event.address}
        </p>
        <p className="text-sm text-neutral-600 font-light md:text-lg">
          {new Date(event.startDate).toLocaleDateString(i18n.language, {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          {' | '}
          {new Date(event.startDate).toLocaleTimeString(i18n.language, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          })}
          {!!event.endDate && (
            <>
              {` - `}
              {new Date(event.endDate).toLocaleDateString(i18n.language, {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
              {' | '}
              {new Date(event.endDate).toLocaleTimeString(i18n.language, {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              })}
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default EventInfo;
